<ng-container *ngIf="structures$ | async as structures">
  <ng-container *ngIf="isShowNormalCarousel$ | async; else summaryTemplate">
    <!-- For desktop devices -->
    <app-carousel-structure [data]="structures.estruturas"></app-carousel-structure>
  </ng-container>
  <ng-template #summaryTemplate>
    <!-- For mobile devices -->
    <app-carousel-summary-structure [data]="structures.estruturas"></app-carousel-summary-structure>
  </ng-template>
</ng-container>
